"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx } from 'react/jsx-runtime';
import { EditorTagBadge, EditorTagBadgeIcon } from '../../ComboBox/Badges/EditorTagBadge/index.mjs';
import { SvgIconType } from '../../SvgIcon/svg-icon-type.mjs';
import { forwardRef } from 'react';

const DeprecatedFormula = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsxs(EditorTagBadge, { variant: "static-value", ref, onClick: props.onClick, onDelete: props.onDelete, children: [
    /* @__PURE__ */ jsx(EditorTagBadgeIcon, { type: SvgIconType.Function }),
    " Deprecated formula"
  ] });
});
function DeprecatedFormulaDropdown(_) {
  return /* @__PURE__ */ jsx("div", { className: "flex flex-col justify-center font-medium text-slate-12 py-4", children: "This formula is deprecated and cannot be edited." });
}

export { DeprecatedFormula, DeprecatedFormulaDropdown };
